import { withDependencies } from '@wix/thunderbolt-ioc'
import { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { name } from './symbols'
import type { ExtraSiteHeightHandlers } from './types'
import {
	BrowserWindow,
	BrowserWindowSymbol,
	ComponentsStylesOverridesSymbol,
	IComponentsStylesOverrides,
	IStructureAPI,
	StructureAPI,
} from '@wix/thunderbolt-symbols'

const extreSiteHeightId = 'EXTRA_SITE_HEIGHT'

const extraSiteHeightFactory = (
	structureApi: IStructureAPI,
	window: NonNullable<BrowserWindow>,
	ComponentsStylesOverrides: IComponentsStylesOverrides
): IModelUpdatesHandlersImplementor<ExtraSiteHeightHandlers> => {
	return {
		featureName: name,
		handlers: {
			addExtraSiteHeightToShellStructure: async ({ extraSiteHeight }) => {
				const isComponentInDynamicStructure = structureApi.isComponentInDynamicStructure(extreSiteHeightId)

				if (extraSiteHeight === 0) {
					if (isComponentInDynamicStructure) {
						structureApi.removeComponentFromDynamicStructure(extreSiteHeightId)
					}
					return
				}

				if (!isComponentInDynamicStructure) {
					await structureApi.addComponentToDynamicStructure(extreSiteHeightId, {
						componentType: 'DivWithChildren',
						components: [],
					})
				}

				ComponentsStylesOverrides.update({
					[extreSiteHeightId]: {
						position: 'relative',
						height: `${extraSiteHeight}px`,
					},
				})
			},
		},
	}
}
export const ExtraSiteHeight = withDependencies(
	[StructureAPI, BrowserWindowSymbol, ComponentsStylesOverridesSymbol],
	extraSiteHeightFactory
)
